import TokenResource from "./TokenResource";

export default class OptionPairResource extends TokenResource {
	text = "";
	value = "";
	description = "";
	sortOrder = 0;

	static listUrl(
		searchParams?: Readonly<Record<string, string | number>> | undefined
	) {
		if (searchParams && Object.keys(searchParams).length) {
			const { name } = searchParams;
			return `${this.urlRoot}/list/${name}`;
		}
		throw new Error(
			`Couldn't retrieve optionPairs with name ${
				searchParams ? searchParams.name : null
			}`
		);
	}

	pk() {
		return `${this.description}|${this.value}`;
	}

	static urlRoot = "/api/optionpairs";
}
